export enum TopBarNoticeKind {
  ONBOARDING = 'onboarding',
  HEALTH_UNHEALTHY = 'health_unhealthy',
  HEALTH_UNKNOWN = 'health_unknown',
}
